import * as React from 'react';

var Colgroup = function Colgroup(_ref) {
  var columns = _ref.columns;
  return /*#__PURE__*/React.createElement("colgroup", null, columns.map(function (c, index) {
    return /*#__PURE__*/React.createElement("col", {
      key: "".concat(c.prop, "-").concat(index),
      style: {
        width: c.width,
        minWidth: c.width
      }
    });
  }));
};

export default Colgroup;